// Copyright (c) 2016 Deere & Company

export default Object.freeze({
  A_LAYOUT_WITH_THAT_NAME_ALREADY_EXISTS: "A Layout with that name already exists",
  ACCEPT: "Accept",
  ACCEPT_ALL: "Accept All",
  ACCEPT_REJECT_TRANSFER_PENDING: "Approval Pending",
  ACCEPTED: "Accepted",
  ACCOUNT: "Account",
  ACCOUNT_ADDRESS: "Account Address",
  ACCOUNT_COUNTRY: "Account Country",
  ACCOUNT_END: "Account End",
  ACCOUNT_NAME: "Account Name",
  ACCOUNT_NUMBER: "Account Number",
  ACCOUNT_NUMBER_REQUIRED: "Account Number Required",
  ACCOUNTS: "Accounts",
  ACCUMULATED_DAYS_ON_RENT: "Accumulated Days On Rent",
  ACCUMULATED_DAYS_RENTED: "Accumulated Days Rented",
  ACTIONS: "Actions",
  ACTIVE_WARRANTY: "Active Warranty",
  ACTIVE_WARRANTY_CLICK_FOR_DETAIL: "Active Warranty (Click for detail)",
  ACTUAL_AUDIT: "Actual Audit",
  ACTUAL_AUDIT_DATE: "Actual Audit Date",
  ACTUAL_COURIER_NAME: "Actual Courier Name",
  ACTUAL_HOURS: "Actual Hours",
  ADD_CLAIM: "Add Claim",
  ADD_CLAIMS: "Add Claims",
  ADD_COMPONENT: "Add Component",
  ADD_OPTION: "Add Option",
  ADD_REP: "Additional Repair",
  ADD_TO_AUDIT: "Add to Audit",
  ADDITIONAL: "Additional",
  ADDITIONAL_COMMENTS: "Additional Comments",
  ADDITIONAL_REPAIR: "Additional Repair",
  ADDITIVE: "Additive",
  ADDRESS: "Address",
  ADDRESS_LINE1: "Address Line 1",
  ADDRESS_LINE1_REQUIRED: "Address Line 1 Required",
  ADDRESS_LINE2: "Address Line 2",
  ADJ_CLM: "Adjust Claim",
  ADJUST_CLAIM: "Adjust Claim",
  ADJUSTED_HOURS: "Adjusted Hours",
  ADJUSTED_QUANTITY: "Adjusted Quantity",
  ADJUSTMENT_TYPE: "Adjustment Type",
  ADVANCED_CLAIM_SUMMARY: "Advanced Claim Summary",
  AFTER_DELIVERY_INSPECTION: "AFTER DELIVERY INSPECTION",
  AGENCY_NAME: "Agency Name",
  ALL: "All",
  ALL_ACCOUNTS: "All Accounts",
  ALL_CLAIMS: "All Claims",
  ALL_CLAIMS_ARE_SUBJECT_TO_REVIEW: "All claims are subject to review (see JD WAM 110.08 for further info)",
  ALL_CLAIMS_TAB: "All Claims ({count, number})",
  ALL_PART_REQUESTS: "All Part Requests",
  ALL_PART_REQUESTS_WITH_COUNT: "All Part Requests ({count})",
  ALL_PARTS_RETURNED: "All Parts Returned",
  AMOUNT: "Amount",
  AMOUNT_1: "Amount 1",
  AMOUNT_2: "Amount 2",
  AMOUNT_3: "Amount 3",
  AMOUNT_OF_USE: "Amount of Use",
  AMOUNT_OF_USE_HISTORY_WITH_COUNT: "Amount of Use History ({count})",
  AMOUNT_OF_USE_IS_REQUIRED: "Amount of Use is required",
  AMOUNT_OF_USE_REQUIRED: "Amount of use required",
  AMOUNT_OF_USE_UNITS_REQUIRED: "Amount of use units required",
  AMOUNT_RECORDED: "Amount Recorded",
  AMOUNT_TO_BE_DEBITED: "Amount to be Debited",
  APLYPIP: "Apply PIP",
  APPLICATION: "Application",
  APPLICATION_IS_REQUIRED: "Application is required",
  APPLY: "Apply",
  APPLY_TRAVEL: "Apply Travel",
  APPROVAL_DEALER_COMMENTS: "Approval Dealer Comments",
  APPROVAL_DETAILS: "Approval Details",
  APPROVAL_LEVELS: "Approval Levels",
  APPROVAL_REMARKS: "Approval Remarks",
  APPROVAL_STATUS: "Approval Status",
  APPROVE: "Approve",
  APPROVE_LABOR_RATE: "Approve Labor Rate",
  APPROVE_MACHINE_STATUS_UPDATE: "Approve Machine Status Update",
  APPROVE_PIP_CODE_REQUEST: "Approve PIP Code Request",
  APPROVE_SPECIAL_ALLOWANCE_CLAIM: "Approve Special Allowance Claim",
  APPROVED: "Approved",
  APPROVED_CORE_VALUE: "Approved Core Value",
  APPROVED_DATE_CANNOT_BE_BEFORE_SETUP_DATE: "Approved date cannot be before setup date",
  APPROVED_DIAGNOSTIC_AMOUNT: "Approved Diagnostic Amount",
  APPROVED_DIAGNOSTIC_HOURS: "Approved Diagnostic Hours",
  APPROVED_IS_REQUIRED: "Approved is required",
  APPROVED_LABOR_ADDITIVE: "Approved Labor Additive",
  APPROVED_LABOR_AMOUNT: "Approved Labor Amount",
  APPROVED_LABOR_HOURS: "Approved Labor Hours",
  APPROVED_LABOR_TOTAL: "Approved Labor Total",
  APPROVED_ON_SHELF_COST: "Approved On Shelf Cost",
  APPROVED_OTHER_CREDITS: "Approved Other Credits",
  APPROVED_PARTS: "Approved Parts",
  APPROVED_PARTS_ADDITIVE: "Approved Parts Additive",
  APPROVED_PARTS_TOTAL: "Approved Parts Total",
  APPROVED_REJECTED: "Approved/Rejected",
  APPROVED_REPAIR_AMOUNT: "Approved Repair Amount",
  APPROVED_REPAIR_HOURS: "Approved Repair Hours",
  APPROVED_TAXES_TOTAL: "Approved Taxes Total",
  APPROVED_TRAVEL_TOTAL: "Approved Travel Total",
  APPROVER: "Approver",
  ASCENDING: "Ascending",
  ATTACHMENTS: "Attachments",
  AUDIT_NUMBER: "Audit Number",
  AUDIT_PLANNED: "Audit Planned",
  AUDIT_REQUIREMENT: "Audit Requirement",
  AUDIT_RESULTS: "Audit Results",
  AUDIT_STATUS: "Audit Status",
  AUDIT_SUBMITTED_SUCCESSFULLY: "Audit Submitted Successfully",
  AUDIT_SUMMARY: "Audit Summary",
  AUDIT_TYPE: "Audit Type",
  AUDITS: "Audits",
  AUDITS_DUE_WITH_COUNT: "{countToDisplay} audits due",
  AUDITS_DUE_WITHIN_30_DAYS: "{countToDisplay} {count, plural, one {audit} other {audits}} due within 30 days",
  AUDITS_PAST_DUE_WITH_COUNT: "{countToDisplay} {count, plural, one {audit} other {audits}} past due",
  AUTHORIZATION_NUMBER: "Authorization Number",
  AUTO_SUBMIT_FROM_DEALER_BUSINESS_SYSTEM: "Auto Submit from Dealer Business System",
  AVAILABLE: "AVAILABLE",
  AVAILABLE_COLUMNS: "Available Columns",
  AVERAGE_DIAGNOSTICS_HOURS: "Average Diagnostics Hours",
  AVERAGE_LUG_HEIGHT: "Average Lug Height",
  AVERAGE_LUG_HEIGHT_IS_REQUIRED: "Average Lug Height is required",
  AVERAGE_REPAIR_HOURS: "Average Repair Hours",
  AVERAGE_REPLACEMENT_HOURS: "Average Replacement Hours",
  AVERAGE_TECH_PAY_RATE: "Average Tech Pay Rate",
  BACK: "Back",
  BACK_TO_AUDIT: "Back to Audit",
  BASE_MACHINE: "Base Machine",
  BASE_MACHINE_IMPLEMENTS: "Base Machine Implements",
  BASE_MACHINE_PIN: "Base Machine PIN",
  BASIC_WARRANTY_ENDS: "Basic Warranty Ends",
  BASIC_WARRANTY_ESTIMATOR: "Basic Warranty Estimator",
  BASIC_WARRANTY_STARTS: "Basic Warranty Starts",
  BASIS_FOR_SETTLEMENT: "Basis For Settlement",
  BASIS_FOR_SETTLEMENT_AUDIT_COMMENTS: "Basis For Settlement / Audit Comments",
  BASIS_FOR_SETTLEMENT_IS_REQUIRED: "Basis For Settlement is required",
  BATTERY: "Battery",
  BEGIN_DATE: "Begin Date",
  BRANCH: "Branch",
  BUILT: "Built",
  BUSINESS_END: "Business End",
  CAN_THE_MACHINE_BE_PUT_BACK_INTO_SERVICE: "Can the Machine be put back into Service?",
  CANCEL: "Cancel",
  CERTIFIED_LETTER_SENT: "Certified Letter Sent",
  CGST: "CGST",
  CHANGE_RESPONSIBLE_DEALER: "Change Responsible Dealer",
  CHANGE_STATUS: "Change Status",
  CHANGE_STATUS_FOR: "Change Status for {pin}",
  CHANGED: "Changed",
  CHANGED_BY: "Changed By",
  CHANGED_ON: "Changed On",
  CHINESE: "Chinese",
  CITY: "City",
  CITY_REQUIRED: "City Required",
  CLAIM: "Claim",
  CLAIM_COUNT_WITH_PARENTHESIS: "({countToDisplay} {count, plural, one {Claim} other {Claims}})",
  CLAIM_DEBIT: "Claim Debit",
  CLAIM_DETAILS: "Claim Details",
  CLAIM_DRAFT: "Draft",
  CLAIM_HISTORY: "24 Month Claim History",
  CLAIM_HISTORY_WITH_COUNT: "24 Month Claim History ({count})",
  CLAIM_NUMBER: "Claim Number",
  CLAIM_RECOVER_PERCENTAGE: "({percentage}%)",
  CLAIM_SEARCH: "Claim Search",
  CLAIM_STATUS: "Claim Status",
  CLAIM_TYPE: "Claim Type",
  CLAIM_TYPES: "Claim Types",
  CLAIM_UPDATED_SUCCESSFULLY: "Claim Updated Successfully",
  CLAIM_VALUE: "Claim Value",
  CLAIM_VALUE_DETAILS: "Claim Value Details",
  CLAIM_WITH_NUMBER: "Claim {claimNumber}",
  CLAIMS: "Claims",
  CLAIMS_IN_PROGRESS: "Claims In Progress",
  CLAIMS_IN_PROGRESS_WITH_COUNT: "Claims In Progress ({count})",
  CLAIMS_OVERVIEW: "Claims Overview",
  CLAIMS_OVERVIEW_TAB: "Claims Overview ({count})",
  CLAIMS_WITH_COUNT: "{count} Claims",
  CLICK_FOR_DETAILS: "(Click for Details)",
  CLICK_TO_VIEW_ALL: "Click to View All",
  CLOSE: "Close",
  CLOSED_PART_REQUESTS: "Closed Part Requests",
  CLOSING: "Closing",
  CLOSING_ACCOUNT: "Closing Account",
  CLOSING_ACCOUNT_WITH_COUNT: "Closing account ({count})",
  CODE: "Code",
  COLLAPSE_ALL: "Collapse All",
  COMMENT: "Comment",
  COMMENTS: "Comments",
  COMMENTS_IS_REQUIRED: "Comments are required",
  COMMENTS_TO_DEALER: "Comments to Dealer",
  COMMON_LABOR_TYPES_WARNING: "Not all the Labor types available for the selected accounts",
  COMPANY: "Company",
  COMPANY_CONTRIBUTION: "Company Contribution",
  COMPANY_CONTRIBUTION_IS_REQUIRED: "Company Contribution is Required",
  COMPLAINT_CAUSE: "What was the cause of the complaint?",
  COMPLAINT_CAUSE_IS_REQUIRED: "Complaint cause is required",
  COMPLAINT_CORRECTION: "How was the complaint corrected?",
  COMPLAINT_CORRECTION_IS_REQUIRED: "Complaint correction is required",
  COMPLETE: "Complete",
  COMPLETED: "Completed",
  COMPLETED_BY: "Completed By",
  COMPLETED_DATE: "Completed Date",
  COMPLETED_IN_LAST_24_MONTHS: "Completed in Last 24 Months",
  COMPLETION_STATUS: "Completion Status",
  COMPONENT: "Component",
  COMPONENT_CODE: "Component Code",
  COMPONENT_CREATED_SUCCESSFULLY: "Component Created Successfully",
  COMPONENT_DELETED_SUCCESSFULLY: "Component Deleted Successfully",
  COMPONENT_SERIAL_NUMBER: "Component Serial Number",
  COMPONENT_SUCCESSFULLY_UPDATED: "Component Successfully Updated",
  COMPONENTS: "Components",
  CONFIRM: "Confirm",
  CONFIRM_ADDITIONAL_REPAIR: "Are you sure you want to add an additional repair?",
  CONFIRM_ADJUST_CLAIM: "Are you sure you want to adjust this Claim?",
  CONFIRM_CLOSING_ACCOUNT: "Are you sure you want to accept this transfer?",
  CONFIRM_COPY_CLAIM: "Are you sure you want to copy this Claim?",
  CONFIRM_DELETE_ATTACHMENT: "Are you sure you want to delete this attachment?",
  CONFIRM_DELETE_CLAIM: "Are you sure you want to delete this Claim?",
  CONFIRM_DELETE_REGISTRATION: "Are you sure you want to delete this Registration?",
  CONFIRM_EDIT_CLAIM: "Are you sure you want to edit this Claim?",
  CONFIRM_RECONCILE_CLAIM: "Are you sure you want to reconcile this Claim?",
  CONFIRM_RESEND_XML: "Are you sure you want to resend the XML? Please allow 24-48 hours for it to be visible.",
  CONFIRM_SKIP_AUDIT: "Are you sure you want to skip this audit?",
  CONFIRM_UNDO_REGISTRATION: "Are you sure you want to undo this Registration?",
  CONTACTED: "Contacted",
  CONTAINS: "Contains",
  CONTRACT_NUMBER: "Contract Number",
  CONTRACT_PURCHASED: "Contract Purchased",
  CONTRACT_TYPE: "Contract Type",
  COPY_CLAIM: "Copy Claim",
  CORE: "Core",
  CORE_VALUE: "Core Value",
  COUNTRY: "Country",
  COUNTRY_REQUIRED: "Country Required",
  COURIER_ACCOUNT_NUMBER: "Courier Account Number",
  COURIER_NAME: "Courier Name",
  COVERAGE_DECISION: "Coverage Decision",
  COVERAGE_TYPE: "Coverage Type",
  CRDMEM: "Credit Memo",
  CREATE: "Create",
  CREATE_CLAIM: "Create Claim",
  CREATE_LAYOUT: "Create Layout",
  CREATE_NON_TRACKED_PIN_HELP_TEXT: "Before you can file a claim on this product, you need to let us know some important information about it",
  CREATE_PIP_CLAIM: "Create PIP Claim",
  CREATE_PIP_CLAIMS: "Create PIP Claims",
  CREATE_PRODUCT_RECORD: "Create Product Record",
  CREATE_REQUEST: "Create Request",
  CREATE_TRANSFER_PENDING: "Transfer Pending",
  CREATE_TRANSFER_SERVICE_UNAVAILABLE: "Create Transfer Service Unavailable",
  CREATED: "Created",
  CREATED_BY: "Created By",
  CREATED_DATE: "Created Date",
  CREATED_ON: "Created On",
  CREATION_DATE: "Creation Date",
  CREDIT_MEMO: "Credit Memo",
  CREDIT_MEMO_DATE: "Credit Memo Date",
  CREDIT_MEMO_ISSUE_DATE: "Credit Memo Issued",
  CREDIT_MEMO_NUMBER: "Credit Memo Number",
  CREDIT_MEMO_PROCESS_DATE: "Credit Memo Processed",
  CREDIT_MEMO_SELECTED: "Credit Memo Selected",
  CREDIT_MEMOS: "Credit Memos",
  CRITERIA: "Criteria",
  CRT: "Create",
  CSV_SEPARATOR: "CSV Separator",
  CURRENCY: "Currency",
  CURRENT: "Current",
  CURRENT_ACCOUNT: "Current Account",
  CURRENT_AMOUNT_OF_USE: "Current Amount of Use",
  CURRENT_CUSTOMER: "Current Customer",
  CURRENT_DEALER: "Current Dealer",
  CURRENT_DEALER_DISTANCE: "Current Dealer Distance",
  CURRENT_DEALER_LAST_SERVICE_DATE: "Current Dealer Last Service Date",
  CURRENT_DEALER_LOCATION: "Current Dealer Location",
  CURRENT_HOURS: "Current Hours",
  CURRENT_QUANTITY: "Current Quantity",
  CURRENT_RESPONSIBLE_DEALER: "Current Responsible Dealer",
  CURRENT_VALUES: "Current Values",
  CURRENTLY_ON_RENT: "Currently On Rent",
  CUSTOM_RANGE: "Custom Range",
  CUSTOM_VALUES: "Custom Values",
  CUSTOMER: "Customer",
  CUSTOMER_CONTRIBUTION: "Customer Contribution",
  CUSTOMER_CONTRIBUTION_IS_REQUIRED: "Customer Contribution is Required",
  CUSTOMER_CREATED_SUCCESSFULLY: "Customer created successfully",
  CUSTOMER_DETAILS: "Customer Details",
  CUSTOMER_DETAILS_UPDATED_SUCCESSFULLY: "Customer details updated successfully",
  CUSTOMER_INFORMATION: "Customer Information",
  CUSTOMER_INFORMATION_IS_REQUIRED: "Customer Information is required.",
  CUSTOMER_INVALID: "Customer could not be found or created, please search for a customer",
  CUSTOMER_NAME: "Customer Name",
  CUSTOMER_NAME_IS_REQUIRED: "Customer Name is required.",
  CUSTOMER_NOT_FOUND: "Customer Not Found",
  CUSTOMER_REQUIRED: "Customer required",
  CUSTOMER_RESOLUTION: "Customer Resolution",
  CUSTOMER_RESOLUTION_IS_REQUIRED: "Customer Resolution is Required",
  CUSTOMER_SEARCH: "Customer Search",
  CUSTOMER_UPDATED_SUCCESSFULLY: "Customer updated successfully",
  DAMAGED_MACHINES_HELP_TEXT: "For damaged machines, warranty will be automatically suspended until this form is reviewed and approved by the TCSM to reinstate warranty. Damaged machines qualify for Mandatory and Safety PIPs only.",
  DATE: "Date",
  DATE_FORMAT: "Date Format",
  DATE_ISSUED: "Date Issued",
  DATE_OF_CERTIFIED_LETTER: "Date of Certified Letter",
  DATE_OF_EVENT_CAUSING_DAMAGE: "Date of Event Causing Damage",
  DATE_OF_LAST_PERSONAL_CONTACT: "Date of Last Personal Contact",
  DATE_RECALLED_PART_WAS_SHIPPED_SENT: "Date Recalled Part was Shipped/Sent",
  DATE_REFUSED: "Date Refused",
  DATE_SUBMITTED: "Date Submitted",
  DAYS_FROM_REGISTRATION: "Days from Registration",
  DAYS_LEFT: "Days Left",
  DAYS_LEFT_WITH_COUNT: "{daysToDisplay} {days, plural, one {Day} other {Days}} Left",
  DAYS_ON_RENT: "Days Rented",
  DAYS_REMAINING: "Days Remaining",
  DAYS_REMAINING_WITH_COUNT: "{daysToDisplay} {days, plural, one {Day} other {Days}} Remaining",
  DAYS_TO_DISPLAY: "Days to Display",
  DBS: "DBS",
  DEALER: "Dealer",
  DEALER_ACCOUNT: "Dealer Account",
  DEALER_ACCOUNT_IS_REQUIRED: "Dealer Account is required",
  DEALER_ACCOUNTS: "Dealer Accounts",
  DEALER_CITY: "Dealer City",
  DEALER_COMMENTS: "Dealer Comments",
  DEALER_CONTRIBUTION: "Dealer Contribution",
  DEALER_CONTRIBUTION_IS_REQUIRED: "Dealer Contribution is Required",
  DEALER_HIERARCHY_ACCOUNT: "{account} ({industryIndicator})",
  DEALER_INVOICE_NUMBER: "Dealer Invoice Number",
  DEALER_INVOICE_UPDATED: "Dealer Invoice Updated",
  DEALER_INVOICE_UPDATES: "Dealer Invoice",
  DEALER_INVOICES: "Dealer Invoices",
  DEALER_LOCATION: "Dealer Location",
  DEALER_LOCATION_FILTER: "Filter Locations",
  DEALER_LOCATION_IS_REQUIRED: "Dealer Location is required",
  DEALER_LOCATIONS: "Dealer Locations",
  DEALER_NAME: "Dealer Name",
  DEALER_PHONE: "Dealer Phone",
  DEALER_POSTAL_CODE: "Dealer Postal Code",
  DEALER_RECOMMENDATIONS: "Dealer Recommendations",
  DEALER_RECOMMENDATIONS_TAB: "Dealer Recommendations ({count})",
  DEALER_REVIEW_REQUEST_SUCCESSFULLY: "Dealer Reviewed Successfully",
  DEALER_SEARCH: "Search Dealer",
  DEALER_SEARCH_CHOOSE_CITY_NAME_ACCOUNT: "Enter Name, City, or Account to search for dealers",
  DEALER_STATE: "Dealer State",
  DEALER_SUBMISSION_WITH_CURRENCY: "Dealer Submission ({currency})",
  DEALER_TRANSFER_HISTORY: "Dealer Transfer History",
  DEALER_TRANSFER_REQUEST_SUCCESSFULLY: "Dealer Transfer Request Queued Successfully",
  DEALER_WARRANTY: "Dealer Warranty",
  DEALERS: "Dealers",
  DEALERSHIP: "Dealership",
  DEBIT: "Debit",
  DEBIT_AMOUNT: "Debit Amount",
  DEBIT_FOR_CLAIM_NUMBER: "Debit for {claimNumber}",
  DEBIT_REQUIRED: "Debit Required",
  DEBIT_REQUIRED_STATUS: "Debit Required Status",
  DEBIT_SUBMITTED_SUCCESSFULLY: "Debit Submitted Successfully",
  DEBIT_TYPE: "Debit Type",
  DEBITED: "Debited",
  DEBITS_TO_THIS_CLAIM_MUST_BE_COMPLETED_THROUGH_MANUAL_DEBIT_PROCESS: "Debits to this claim must be completed through the manual debit process",
  DECIMAL_FORMAT: "Decimal Format",
  DECISION_UPDATED: "Decision Updated",
  DECLINE: "Decline",
  DEDUCTIBLE: "Deductible",
  DEERE_REMARKS: "Deere Remarks",
  DEFAULT_WARRANTY: "Default Warranty",
  DEL: "Delete",
  DELETE: "Delete",
  DELETE_ATTACHMENT: "Delete Attachment",
  DELETE_CLAIM: "Delete Claim",
  DELETE_REGISTRATION: "Delete Registration",
  DELETE_REGISTRATION_SUCCESS: "Registration Delete Successful",
  DELETED: "Deleted",
  DELETED_BY: "Deleted By",
  DELIVERED: "Delivered",
  DELIVERED_IS_REQUIRED: "Delivered is required",
  DELIVERY_DATE: "Delivery Date",
  DELIVERY_DATE_REQUIRED: "Delivery Date required",
  DELIVERY_DATES: "Delivery Dates",
  DELIVERY_NO_DOCUMENTS: "Delivery, No Documents",
  DEMO_RENTAL_BEGIN_DATE: "Demo/Rental Begin Date",
  DEMO_RENTAL_CHOOSE_DEALERS_STATUS: "Select Dealers and Status",
  DEMO_RENTAL_END_DATE: "Demo/Rental End Date",
  DEMO_RENTAL_HISTORY: "Demo Rental History",
  DENY: "Deny",
  DENY_MACHINE_STATUS_UPDATE: "Deny Machine Status Update",
  DENY_PIP_CODE_REQUEST: "Deny PIP Code Request",
  DESCENDING: "Descending",
  DESCRIPTION: "Description",
  DESCRIPTION_OF_DAMAGE: "Description of Damage",
  DESCRIPTION_OF_EVENT_CAUSING_DAMAGE: "Description of Event Causing Damage",
  DESELECT_ALL: "Deselect All",
  DETAILS: "Details",
  DIAGNOSTICS_COVERED: "Diagnostics Covered",
  DIS_VSR: "Display Messages",
  DISPLAY: "Display",
  DISPLAY_CLAIM: "Display Claim",
  DISPLAY_CREDIT_MEMO: "Display Credit Memo",
  DISPLAY_FORMAT: "Display Format",
  DISPLAY_PRODUCT: "Display Product",
  DISPLAY_TAG: "Display Tag",
  DISTANCE: "Distance",
  DISTANCE_FROM_CURRENT_DEALER: "Distance from Current Dealer",
  DISTANCE_FROM_POTENTIAL_DEALER: "Distance from Potential Dealer",
  DIVISION: "Division",
  DIVISION_SUMMARY: "Division Summary",
  DO_YOU_WANT_TO_SAVE_YOUR_CHANGES: "Do you want to save your changes?",
  DOES_NOT_CONTAIN: "Does not contain",
  DOWNLOAD_TO_EXCEL: "Download to Excel",
  DOWNTIME: "Downtime",
  DOWNTIME_IS_REQUIRED: "Downtime is required",
  DRAFT: "Save as Draft",
  DTAC_CASE: "DTAC Case",
  DTAC_CASE_NUMBER: "DTAC Case Number",
  DTAC_SOLUTION: "DTAC Solution",
  DUE_DATE: "Due Date",
  DUE_WITHIN_3_MONTHS: "Due Within 3 Months",
  DUPLICATE_PIN_PLATE: "Duplicate PIN Plate",
  DUPLICATE_PIN_PLATE_REQUEST_UPDATED: "Duplicate PIN Plate Request Updated",
  DUPLICATE_PIN_PLATE_SUCCESSFULLY_CREATED: "Duplicate PIN Plate Request Successfully Created",
  DUPLICATE_PIN_PLATE_WITH_COUNT: "Duplicate PIN Plate Request ({count})",
  EDIT: "Edit",
  EDIT_CUSTOMER: "Edit Customer",
  EDIT_LAYOUT: "Edit Layout",
  EDIT_WITH_PARENTHESES: "(Edit)",
  EFFECTIVE: "Effective",
  EFFECTIVE_DATE: "Effective Date",
  EMAIL: "Email",
  EMISSIONS_PART_SEARCH: "Emissions Part Search",
  END_DATE: "End Date",
  END_USE: "End Use",
  END_USE_CODE: "End Use Code",
  END_USE_CODE_REQUIRED: "End Use Code required",
  ENDS_WITH: "Ends with",
  ENGLISH: "English",
  ENTER_A_NUMBER_BETWEEN_0_AND_1000: "Enter a number between 0 and 1000",
  ENTER_A_NUMBER_BETWEEN_0_AND_10000: "Enter a number between 0 and 10000",
  ENTER_A_NUMBER_FROM_1_TO_9999: "Enter a number from 1 to 9999",
  ENTER_A_PART_NUMBER: "Enter a part number",
  ENTER_COMMENTS_BEFORE_ACCEPTING: "Enter comments before accepting",
  EQUALS: "Equals",
  ERROR: "ERROR:",
  ERROR_MESSAGE_TITLE: "An error has occurred:",
  ERROR_MESSAGES: "Error Messages",
  ERROR_MESSAGES_TITLE: "Multiple errors have occurred:",
  ERROR_NETWORK_ISSUES: "A Network error prevented some data from being loaded - please try again",
  ERROR_NO_DATA_TO_EXPORT: "No data to export",
  ERROR_RETRIEVING_CUSTOMER_INFORMATION: "Error retrieving customer information",
  ERROR_SAP: "Unable to connect to server.  If the problem continues, use the 'Contact Us' link to get assistance resolving your issue.",
  ERROR_SESSION: "Your session has expired.  Refresh the page to log back in.",
  ERROR_UNHANDLED: "The system encountered an unexpected error.  If the problem continues please use our 'Help' feature or the 'Contact Us' link to get assistance resolving your issue.",
  ERROR_UPLOADING_FILE: "File was not added",
  ESTIMATED_BASIC_DATE: "Estimated Basic Date",
  ESTIMATED_BASIC_DAYS: "Estimated Basic Days",
  ESTIMATES_MAY_NOT_REFLECT_DEMO_STATUS_OR_HOURS_NOT_YET_REPORTED: "Estimates may not reflect demo status or hours not yet reported",
  EXCEEDS_DEMO_THRESHOLD: "Exceeds Demo Threshold",
  EXCHANGE_RATE: "Exchange Rate",
  EXCLUDED_PINS_ARE_NOT_INCLUDED_IN_THIS_REPORT: "Excluded PINs are not included in this report.",
  EXECUTE: "Execute",
  EXPAND_ALL: "Expand All",
  EXPECTED_FIRST_USE: "Expected First Use",
  EXPIRATION_DATE: "Expiration Date",
  EXPIRED: "Expired",
  EXPIRED_PART_REQUESTS: "Expired Part Requests",
  EXPIRED_PIPS: "Expired PIPs",
  EXPIRES: "Expires",
  EXPIRING_SOON: "Expiring Soon",
  EXPORT: "Export",
  EXTENDED_WARRANTY: "Extended Warranty",
  FACTORY: "FACTORY",
  FACTORY_NAME: "Factory Name",
  FAILED: "Failed",
  FAILED_AREA: "Failed Area",
  FAILED_AREA_IS_REQUIRED: "Failed Area is required",
  FAILED_DATE: "Failed Date",
  FAILED_DATE_IS_REQUIRED: "Failed Date is required",
  FAILED_MODE: "Failed Mode",
  FAILED_MODE_COMMENTS: "Failed Mode Comments",
  FAILED_PART: "Failed Part",
  FAILED_PART_DESCRIPTION: "Failed Part Description",
  FAILED_PART_IS_A_REMAN_PART: "Failed Part is a ReMan Part",
  FAILED_PART_IS_REQUIRED: "Failed Part is required",
  FAILED_PART_SERIAL: "Failed Part Serial",
  FAILED_PART_SERIAL_IS_REQUIRED: "Failed Part Serial is required",
  FAILURE_DATE: "Failure Date",
  FAILURE_INFORMATION: "Failure Information",
  FAILURE_MODE: "Failure Mode",
  FAILURE_MODE_IS_REQUIRED: "Failed Mode is required",
  FAILURE_PART: "Failed Part",
  FAILURE_PART_DESCRIPTION: "Failure Part Description",
  FAILURE_PART_IS_REQUIRED: "Failure Part is required",
  FAILURE_TO_RETURN_PARTS_WARNING: "Failure to return requested part(s) may result in a debit.",
  FAVORITES: "Favorites",
  FILE_NAME: "File Name",
  FILE_SIZE_IS_TOO_BIG: "File Size is too Big (Maximum Size: 100 MB)",
  FILE_SIZE_IS_TOO_BIG_CSV: "File Size is too Big (Maximum Size: 1 MB)",
  FILE_UPLOAD_MESSAGE: "Drop Files Here or Click to Add Files (Maximum Size: 100 MB)",
  FILE_UPLOAD_MESSAGE_CSV: "Drop Files Here or Click to Add Files (Maximum Size: 1 MB)",
  FILE_UPLOAD_MESSAGE_IMAGE: "Drag and Drop Images Here or Click to Add Images (Maximum Size: 100 MB).",
  FILE_UPLOAD_MESSAGE_SINGLE: "Drop a Single File Here or Click to Add (Maximum Size: 100 MB)",
  FILE_UPLOAD_UNABLE_TO_READ: "The system was unable to read your file.  Please compare it to the template and try again.",
  FILES: "Files",
  FILTER_PLACEHOLDER: "Filter Results",
  FILTER_WITH_ELLIPSIS: "Filter...",
  FILTERED_BY_COLUMN_ID: "Filtered by {columnId}",
  FIND_CUSTOMER: "Find Customer",
  FINNISH: "Finnish",
  FIRST_MAINTENANCE: "FIRST MAINTENANCE",
  FIRST_NAME: "First Name",
  FIRST_NAME_IS_REQUIRED: "First Name is required",
  FIRST_SHIP_TO_LOCATION: "First Ship To Location",
  FIRST_USE: "First Use",
  FISCAL_YEAR: "Fiscal Year",
  FLUID_SAMPLING_REQUIRED: "Fluid Sampling Required",
  FORWARDED: "Forwarded",
  FRENCH: "French",
  FROM: "From",
  FRWRD: "Forward",
  FULL_DEBIT: "Full Debit",
  GENERAL: "General",
  GERMAN: "German",
  GET_MAINTENANCE_PLANS: "Get Maintenance Plans",
  GOODS_INSTALLATION_VAT: "Goods Installation VAT",
  GRACE_PERIOD: "Grace Period",
  GREATER_THAN: "Greater than",
  GREATER_THAN_OR_EQUALS: "Greater than or equals",
  GROUP_COMPLETE: "Group Complete",
  GST_PERCENTAGE: "GST Percentage",
  HISTORY_TO_DISPLAY: "History to display (days)",
  HOME: "Home",
  HOUR_LIMIT: "Hour Limit",
  HOURS: "Hours",
  HOURS_ON_RENT: "Hours On Rent",
  HSN_SAC_CODE: "HSN/SAC Code",
  IGST: "IGST",
  IMPLEMENTS: "Implements",
  IN_RANGE: "In range",
  INCENTIVE: "Incentive",
  INCENTIVE_PROGRAMS: "Incentive Programs",
  INCLUDE_FULLY_COMPLETE: "Include Fully Complete PIPs",
  INDICATES_REQUIRED_FIELD: "Indicates required field",
  INFO_MESSAGE_TITLE: "A system notification was sent:",
  INFO_MESSAGES: "Info Messages",
  INFO_MESSAGES_TITLE: "Multiple system notifications have been sent:",
  INFO_REQUEST_STATUS_ERROR: "Information is ready to be submitted with this request.",
  INFORMATION: "Information",
  INFORMATION_REQUEST: "Information Request",
  INFORMATION_REQUEST_STATUS: "Information Request Status",
  INPUT_PIN: "Input PIN",
  INSPECTION: "Inspection",
  INSTALLED_BY: "Installed By",
  INSTALLED_BY_IS_REQUIRED: "Installed By is required",
  INTERNAL_DEERE_COMMENTS: "Internal Deere Comments",
  INTERVAL_BEGINS: "Interval Begins",
  INTERVAL_ENDS: "Interval Ends",
  INTERVAL_TYPE_DESCRIPTION: "Interval Type Description",
  INVOICE_ACCOUNT: "Invoice Account",
  INVOICE_DEALER: "Invoice Dealer",
  INVOICE_NUMBER: "Invoice Number",
  INVOICE_REQUEST: "Invoice Request",
  INVOICE_SENT: "Invoice Sent",
  INVOICE_UPDATED_SUCCESSFULLY: "Invoice Updated Successfully",
  INVOICED: "Invoiced",
  INVOICED_TO: "Invoiced to",
  IRC_PIN_MESSAGE: "Customer is an IRC & is entitled to complimentary Travel Time and Mileage for the first 500 hours or 12 months of machine ownership.",
  ISSUED: "Issued",
  ITALIAN: "Italian",
  ITEM: "Item",
  ITEM_NUMBER: "Item Number",
  ITEM_NUMBER_IS_REQUIRED: "Item Number is required",
  JDLINK_EXPIRES: "JDLink Expires",
  JDP_COMMENTS: "JDP Comments",
  JDP_COMMENTS_IS_REQUIRED: "JDP Comments is required",
  JDP_CUSTOMER_RESOLUTION: "JDP Customer Resolution",
  JDP_CUSTOMER_RESOLUTION_IS_REQUIRED: "JDP Customer Resolution is required",
  JDP_REASON: "JDP Reason",
  JDP_REASON_IS_REQUIRED: "JDP Reason is required",
  LABOR: "Labor",
  LABOR_ADDITIVE: "Labor Additive",
  LABOR_ADDITIVE_COMPLETION_DETAIL: "Labor Additive Completion Detail",
  LABOR_ADDITIVE_PIPS: "Labor Additive PIPs",
  LABOR_ADDITIVE_TAB: "Labor Additive ({count})",
  LABOR_ADJUSTMENT: "Labor Adjustment",
  LABOR_COMMENTS: "Labor Comments",
  LABOR_HOURS: "Labor Hours",
  LABOR_ITEM_DETAILS: "Labor - {quantity} {unit} {description}",
  LABOR_RATE_APPROVED_SUCCESSFULLY: "Labor Rate Approved Successfully",
  LABOR_RATE_CHANGE_SUBMITTED: "Labor Rate Change Submitted",
  LABOR_RATE_CHANGES_WITH_COUNT: "Labor Rate Changes ({count})",
  LABOR_RATE_CONFIRM: "The requested rate is lower than the current rate.  Are you sure you want to submit the request?",
  LABOR_RATE_DIFFERENCE_LARGE_INFORMATION_MESSAGE: "Rates in red text indicate an increase of more than 10% from the existing rate",
  LABOR_RATE_HISTORY: "Labor Rate History",
  LABOR_RATE_REJECTED_SUCCESSFULLY: "Labor Rate Rejected Successfully",
  LABOR_RATE_REQUESTS_STATUS: "Labor Rate Requests Status",
  LABOR_RATE_RETURNED_SUCCESSFULLY: "Labor Rate Returned Successfully",
  LABOR_RATES: "Labor Rates",
  LABOR_STATS: "Labor Stats",
  LABOR_TOTAL: "Labor Total",
  LABOR_TYPE: "Labor Type",
  LABOR_VALUE: "Labor Value",
  LABOR_WITH_COUNT: "Labor ({count})",
  LANGUAGE: "Language",
  LAST_LOCATION_FROM: "Last Location From",
  LAST_NAME: "Last Name",
  LAST_NAME_IS_REQUIRED: "Last Name is required",
  LAST_PERSONAL_CONTACT: "Last Personal Contact",
  LAW_ENFORCEMENT_AGENCY_DETAILS: "Law Enforcement Agency Details",
  LAYOUT_CREATED_SUCCESSFULLY: "Layout Created Successfully",
  LAYOUT_DELETED_SUCCESSFULLY: "Layout Deleted Successfully",
  LAYOUT_NAME: "Layout Name",
  LAYOUT_UPDATED_SUCCESSFULLY: "Layout Updated Successfully",
  LEAD_ACCOUNT: "Lead Account",
  LEAD_DEALER: "Lead Dealer",
  LESS_THAN: "Less than",
  LESS_THAN_OR_EQUALS: "Less than or equals",
  LICENSE_PLATE_NUMBER: "License Plate Number",
  LIFETIME: "Lifetime",
  LINE_ITEMS_EXPORT: "Line Items Export",
  LIST: "List",
  LIST_TOTAL: "List Total",
  LOCATION: "Location",
  LOCATION_DUE: "Location Due",
  LOCATIONS: "Locations",
  LOCATIONS_WITH_COUNT: "Locations ({count})",
  MACHINE_ALREADY_REGISTERED_TO_THIS_CUSTOMER: "Machine is already registered to this customer",
  MACHINE_INFORMATION: "Machine Information",
  MACHINE_MODEL_TYPE: "Machine Model/Type",
  MACHINE_MODEL_TYPE_REQUIRED: "Machine Model/Type Required",
  MACHINE_STATUS: "Machine Status",
  MACHINE_STATUS_UPDATE_ACCEPTED: "Machine Status Update Approved",
  MACHINE_STATUS_UPDATE_DOCUMENT: "Machine Status Update Document",
  MACHINE_STATUS_UPDATE_REJECTED: "Machine Status Update Rejected",
  MACHINE_STATUS_UPDATES_WITH_COUNT: "Machine Status Updates ({count})",
  MACHINE_TYPE: "Machine Type",
  MACHINE_TYPE_IS_REQUIRED: "Machine Type is required",
  MACHINE_USE: "Machine Use",
  MAILING_RECIPIENT: "Mailing Recipient (First and Last Name)",
  MAILING_RECIPIENT_REQUIRED: "Mailing Recipient Required",
  MAINTENANCE: "Maintenance",
  MAINTENANCE_PLAN: "Maintenance Plans",
  MAINTENANCE_PLAN_INFO: "Maintenance Plan Information",
  MARK_AS_REVIEW: "Mark as Reviewed",
  MARKETING_INCENTIVE: "Marketing - Incentive",
  MARKETING_JD_PROMISE: "Marketing - JD Promise",
  MARKETING_MAINTENANCE_PLAN: "Marketing - Maintenance Plan",
  MARKETING_MASS_CHANNEL_FOLLOWUP: "Marketing - Mass Channel Followup",
  MARKETING_MASS_CHANNEL_PDI: "Marketing - Mass Channel PDI",
  MASS_CHANNEL_CUSTOMER_FOLLOW_UP: "Mass Channel Customer Follow Up",
  MASS_CHANNEL_CUSTOMER_FOLLOW_UP_HELP_TEXT: "Reminder, please make sure to contact your own legal counsel to determine the appropriate #Do Not Call# procedures within your state and at the federal level before implementing your Follow-up After the Sale Call Program",
  MASS_CHANNEL_PDI_CLAIM: "Mass Channel PDI",
  MASTER_WARRANTY_TYPE: "Master Warranty Type",
  MATERIAL: "Material Number",
  MERCHANDISE: "Merchandise",
  MESSAGE: "Message",
  MESSAGES: "Messages",
  METHOD_OF_CONTACT: "Method of Contact",
  METHOD_OF_CONTACT_IS_REQUIRED: "Method of Contact is required",
  METRIC: "Metric",
  METRICS: "Metrics",
  MILEAGE_LIMIT: "Mileage Limit",
  MOBILE_PHONE: "Mobile Phone",
  MODEL: "Model",
  MODEL_NUMBER: "Model Number",
  MODIFIED: "Modified",
  MONTH_TO_DATE: "Month to date",
  MORE: "More",
  MULTIPLE: "Multiple",
  NAME: "Name",
  NET: "Net",
  NET_AMOUNT: "Net Amount",
  NET_AMOUNT_PAID: "Net Amount Paid",
  NET_TOTAL: "Net Total",
  NEW: "New",
  NEW_ACCOUNT: "New Account",
  NEW_CLAIM: "New Claim",
  NEW_CLAIM_VALUE: "New Claim Value",
  NEW_CUSTOMER_REQUIRED: "New Customer required",
  NEW_DEALER: "New Dealer",
  NEW_DEALER_DISTANCE: "New Dealer Distance",
  NEW_DEALER_LOCATION: "New Dealer Location",
  NEW_LABOR_RATE: "New Labor Rate",
  NEW_REQUEST_ENTER_RATES: "New Request - Enter Rates",
  NEW_STATUS: "New Status",
  NEW_TRANSFER: "New Transfer",
  NEW_TRANSFER_CREATED: "New Transfer Created",
  NEW_VALUE: "New Value",
  NO: "NO",
  NO_ACTIVE_WARRANTY: "No Active Warranty",
  NO_AFFECTED_PINS: "There are no affected PINs under the responsibility of your dealership",
  NO_AUTHORITY_TO_ACCESS: "You do not have authority to access the JDWS. Dealership users please follow up with your Profile Administrator (DPA) to verify authority and Deere users contact Support with a copy of this error",
  NO_CLAIMS: "There are no claims.",
  NO_CUSTOMER_ASSOCIATED: "No Customer Associated",
  NO_CUSTOMER_SELECTED: "No Customer Selected",
  NO_DEALER_INVOICES: "No Dealer Invoices",
  NO_DEALERS_MAPPED: "There are no dealers mapped to your user ID. Please contact system administrator.",
  NO_IF_NO_A_PICTURE_MUST_BE_PROVIDED_AS_EVIDENCE: "No (If no, a picture must be provided as evidence)",
  NO_INFORMATION_AVAILABLE_FOR_THIS_PRODUCT: "No information available for this product",
  NO_LOWERCASE: "No",
  NO_MATCHING_DEALERS: "No dealers match the filter text.",
  NO_OPEN_PART_REQUESTS: "No Open Part Requests",
  NO_OPEN_PIPS: "No Open PIPs",
  NO_PARTS_RETURNED: "No Parts Returned",
  NO_PIP_PRODUCTS: "There are no PIP products.",
  NO_PRODUCT_FOUND: "No Product Found",
  NO_REQUIRED_ITEMS: "There are no required items.",
  NO_RESULTS: "No Results",
  NO_RESULTS_FOUND: "No Results Found",
  NO_ROWS_TO_SHOW: "No Rows To Show",
  NO_SPECIAL_INSTRUCTIONS: "There are no special instructions.",
  NO_TRAVEL: "No Travel",
  NON_RECOVERABLE_TAXES: "Non Recoverable Taxes",
  NON_TRACKED_PINS_HELP_TEXT: "Some products do not appear in Warranty until after registration. Your search matches a range of these products.",
  NON_TRAVEL: "Non-Travel",
  NONE: "None",
  NORMAL: "NORMAL",
  NOT_EQUAL: "Not equal",
  NOTIFICATION_ADDED_SUCCESSFULLY: "Notification added Successfully",
  NOTIFICATION_DELETED_SUCCESSFULLY: "Notification deleted Successfully",
  NOTIFICATION_SEQUENCE_UPDATED_SUCCESSFULLY: "Notification sequence updated successfully",
  NOTIFICATION_UPDATED_SUCCESSFULLY: "Notification updated Successfully",
  NOTIFICATIONS: "Notifications",
  NUMBER_OF_DIAGNOSTICS_OCCURRENCES: "Number of Diagnostics Occurrences",
  NUMBER_OF_OPEN_PIPS: "{number} Open PIPs",
  NUMBER_OF_REPAIR_OCCURRENCES: "Number of Repair Occurrences",
  NUMBER_OF_REPLACEMENT_OCCURRENCES: "Number of Replacement Occurrences",
  OLD_LABOR_RATE: "Old Labor Rate",
  ON_SHELF: "On Shelf",
  ON_SHELF_COST: "On Shelf Cost",
  ONE_ITEM_MUST_BE_SELECTED: "One item must be selected",
  OPEN: "Open",
  OPEN_PART_REQUESTS: "Open Part Requests",
  OPEN_PART_REQUESTS_WITH_COUNT: "Open Part Requests ({count})",
  OPEN_PIP_COUNT: "Open PIP Count",
  OPEN_PIP_PROGRAMS: "PIP Register",
  OPEN_PIPS: "Open PIPs",
  OPEN_PIPS_REPORT: "Open PIP Report",
  OPEN_PIPS_TAB: "Open PIPs ({count})",
  OPERATORS_COMPLAINT: "What was the operator's complaint?",
  OPERATORS_COMPLAINT_IS_REQUIRED: "Operator's complaint is required",
  OPERATORS_MANUAL_NUMBER: "Operator's Manual Number",
  OPTION_CODE: "Option Code",
  OPTION_CODE_CREATED_SUCCESSFULLY: "Option Code Created Successfully",
  OPTION_CODE_DELETED_SUCCESSFULLY: "Option Code Deleted Successfully",
  OPTION_CODES: "Option Codes",
  OR: "or",
  ORIGINAL_CLAIM_VALUE: "Original Claim Value",
  ORIGINAL_SUBMISSION_DATE: "Original Submission Date",
  ORIGINALLY_SUBMITTED: "Originally Submitted",
  OTHER: "Other",
  OTHER_AMOUNT_OF_USE: "Other Amount of Use",
  OTHER_AMOUNT_OF_USE_REQUIRED: "Other Amount of Use Required",
  OTHER_CREDIT: "Other Credit",
  OTHER_CREDIT_1: "Other Credit 1",
  OTHER_CREDIT_2: "Other Credit 2",
  OTHER_CREDIT_3: "Other Credit 3",
  OTHER_CREDIT_ADJUSTMENT: "Other Credit Adjustment",
  OTHER_CREDIT_ITEM_DETAILS: "Other Credit - {description} ({quantity} {unit})",
  OTHER_CREDIT_TOTAL: "Other Credit Total",
  OTHER_CREDITS: "Other Credits",
  OTHER_CREDITS_WITH_COUNT: "Other Credits ({count})",
  OTHER_INSTRUCTIONS: "Other Instructions",
  OUTPUT_PIN: "Output PIN",
  OVERDUE: "Overdue",
  OVERRIDE_ACCOUNT: "Override Account",
  OVERRIDE_EFFECTIVE_DATE: "Override Effective Date",
  OVERRIDE_SUGGESTED_ACCOUNT: "Override Suggested Account",
  OWNERSHIP_STATUS: "Ownership Status",
  OWNERSHIP_STATUS_IS_REQUIRED: "Ownership Status is required",
  PART: "Part",
  PART_1: "Part 1",
  PART_2: "Part 2",
  PART_3: "Part 3",
  PART_4: "Part 4",
  PART_5: "Part 5",
  PART_6: "Part 6",
  PART_7: "Part 7",
  PART_8: "Part 8",
  PART_9: "Part 9",
  PART_10: "Part 10",
  PART_AMONT_OF_USE: "Part Amount of Use",
  PART_FAMILY: "Part Family",
  PART_ITEM_DETAILS: "Parts - {quantity} {description} (Part # {partNumber})",
  PART_NUMBER: "Part Number",
  PART_REQUEST: "Part Request",
  PART_REQUEST_NUMBER: "Part Request {rgaNumber}",
  PART_REQUEST_STATUS: "Part Request Status",
  PART_REQUESTS: "Part Requests",
  PART_REQUESTS_SEARCH_BY_CLAIM_PLACEHOLDER: "Enter Claim Number, Minimum 4 Characters",
  PART_REQUESTS_SEARCH_BY_CLAIM_VALIDATION_ERROR: "Claim search must be at least 4 characters",
  PART_REQUESTS_SEARCH_BY_DTAC_CASE_NUMBER_ERROR: "DTAC Case Number search must be full DTAC Case Number, at least 4 characters",
  PART_REQUESTS_SEARCH_BY_DTAC_CASE_NUMBER_PLACEHOLDER: "Enter full DTAC Case Number",
  PART_REQUESTS_SEARCH_BY_PART_NUMBER_ERROR: "Part Number search must be at least 4 characters",
  PART_REQUESTS_SEARCH_BY_PART_NUMBER_PLACEHOLDER: "Enter Part Number, minimum 4 Characters",
  PART_REQUESTS_SEARCH_BY_PART_REQUEST_ERROR: "Part Request Number search must be at least 4 characters",
  PART_REQUESTS_SEARCH_BY_PART_REQUEST_PLACEHOLDER: "Enter Part Request Number, minimum 4 Characters",
  PART_REQUESTS_SEARCH_BY_PIN_ERROR: "PIN Search must be at least 4 character",
  PART_REQUESTS_SEARCH_BY_PIN_PLACEHOLDER: "Enter PIN, minimum 4 Characters",
  PART_REQUESTS_SEARCH_BY_WORK_ORDER_ERROR: "Work Order search must be full Work Order, at least 2 characters",
  PART_REQUESTS_SEARCH_BY_WORK_ORDER_PLACEHOLDER: "Enter full Work Order",
  PART_REQUESTS_UPDATED_SUCCESSFULLY: "Part Request updated successfully",
  PART_RETURN: "Part Return",
  PART_RETURNS: "Part Returns",
  PART_SERIAL_NUMBER: "Part Serial Number",
  PART_SERIAL_NUMBER_IS_REQUIRED: "Part Serial Number is required",
  PART_TOTAL: "Part Total",
  PART_TYPE: "Part Type",
  PART_USE: "Part Use",
  PART_VALUE: "Part Value",
  PARTIAL_DEBIT: "Partial Debit",
  PARTICIPANT: "Participant",
  PARTS: "Parts",
  PARTS_ADDITIVE: "Parts Additive",
  PARTS_ADJUSTMENT: "Parts Adjustment",
  PARTS_COVERAGE_SEARCH: "Parts Coverage Search",
  PARTS_TEMPLATE: "Parts Template",
  PARTS_USE: "Parts Use",
  PARTS_USE_IS_REQUIRED: "Parts Use is required",
  PARTS_WITH_COUNT: "Parts ({count})",
  PARTS_WITH_PARENTHESES: "Part(s)",
  PAST_DUE: "Past Due",
  PAYER_ACCOUNT: "Payer Account",
  PERCENT_COMPLETE: "Percent Complete",
  PERCENTAGE: "Percentage",
  PERCENTAGE_DEBIT: "Percentage Debit",
  PERCENTAGE_SYMBOL: "{percentage}%",
  PERCENTAGE_TO_DEBIT: "Percent to Debit",
  PERMANENTLY_OUT_OF_SERVICE_MACHINES: "Permanently Out of Service Machines",
  PERMANENTLY_OUT_OF_SERVICE_MACHINES_HELP_TEXT: "For permanently out of service machines, please include a picture of the machine for verification that the machine cannot be rebuilt, repaired, or used at any point in the future. Permanently out of service machines do not qualify for PIPs of any kind.",
  PERSON_RESPONSIBLE: "Person Responsible",
  PHONE: "Phone",
  PHONE_REQUIRED: "Phone Required",
  PICTURE: "Picture",
  PICTURE_REQUEST: "Picture Request",
  PICTURE_REQUEST_STATUS: "Picture Request Status",
  PICTURE_REQUEST_STATUS_ERROR: "Attachments are ready to be submitted with this request.",
  PIN: "PIN",
  PIN_CREATED_SUCCESSFULLY: "PIN Created Successfully",
  PIN_CROSS_REFERENCE: "PIN Cross Reference",
  PIN_INVALID: "PIN Invalid",
  PIN_IS_REQUIRED: "Pin is required",
  PIN_REQUIRED: "PIN Required",
  PIN_SEARCH: "Pin Search",
  PIN_SEARCH_INFORMATION: "Pin Search Information",
  PIN_TRANSFER_INFORMATION: "Pin Transfer Information",
  PINS: "PINs",
  PINS_NOT_REGISTERED: "PINs Not Registered",
  PIP: "PIP",
  PIP_CODE: "PIP Code",
  PIP_CODE_CREATED_SUCCESSFULLY: "PIP code request created successfully",
  PIP_CODE_REQUEST: "PIP Code Request",
  PIP_CODE_REQUEST_APPROVED: "PIP Code Request Approved",
  PIP_CODE_REQUEST_REJECTED: "PIP Code Request Rejected",
  PIP_CODE_REQUESTS_WITH_COUNT: "PIP Code Requests ({count})",
  PIP_COMPLETION_STATUS: "PIP Completion Status",
  PIP_DETAILS: "PIP Details",
  PIP_HISTORY: "PIP History",
  PIP_ID: "PIP #",
  PIP_NUMBER: "PIP Number",
  PIP_PROGRAM: "PIP Program",
  PIP_PROGRAM_IS_REQUIRED: "PIP Program is required",
  PIP_PROGRAMS: "PIP Programs",
  PIP_SEARCH: "PIP Search",
  PIP_STATUS: "PIP Status",
  PIP_TYPE: "PIP Type",
  PIP_TYPES: "PIP Types",
  PIPS: "PIPs",
  PIPS_UNPAID_LABOR_ADDITIVE: "PIPs Unpaid Labor Additive",
  PLAN_DESCRIPTION: "Plan Description",
  PLAN_END_DATE: "Plan End Date",
  PLAN_ENDS: "Plan Ends",
  PLAN_NAME: "Plan Name",
  PLAN_NAME_IS_REQUIRED: "Plan Name is Required",
  PLAN_NAMES: "Plan Names",
  PLAN_START_DATE: "Plan Start Date",
  PLAN_STARTS: "Plan Starts",
  PLANNED_BY: "Planned By",
  PLANT: "Plant",
  PLATE_REQUEST_INFORMATION: "Plate Request Information",
  PLEASE_SELECT_A_LEAD_ACCOUNT: "Please select a lead account",
  PLEASE_SELECT_CLAIM_TYPE: "Please select the claim type",
  POLISH: "Polish",
  PORTUGUESE: "Portuguese",
  POSTAGE_DELIVERY_DATE: "Postage Delivery Date",
  POSTAL_CODE: "Postal Code",
  POSTAL_CODE_REQUIRED: "Postal Code Required",
  POSTAL_TRACKING_NUMBER: "Postal Tracking Number",
  POTENTIAL_RESPONSIBLE_DEALER: "Potential Responsible Dealer",
  PRE_DELIVERY_INSPECTION: "Pre Delivery Inspection",
  PREFERRED_THEME: "Preferred Theme",
  PREPARE_AUDIT: "Prepare Audit",
  PREPARED: "Prepared",
  PREPARING_AUDIT_FOR_WITH_DEALER: "Preparing Audit for {dealer}",
  PREVIOUS_AMOUNT_OF_USE: "Previous Amount of Use",
  PREVIOUS_INVOICE_NUMBER: "Previous Invoice Number",
  PREVIOUS_INVOICE_NUMBER_IS_REQUIRED: "Previous Invoice Number is required",
  PREVIOUS_MONTH: "Previous month",
  PRICE: "Price",
  PRICING_SUMMARY: "Pricing Summary",
  PRIMARY_ACTION: "Primary Action",
  PRIMARY_LANGUAGE: "Primary Language",
  PRINT: "Print",
  PRINT_CLAIM: "Print Claim",
  PRINT_REGISTRATION_FORM: "Print Registration Form",
  PRINT_REGISTRATION_FORM_MESSAGE: "Product registered to First Owner. Would you like to print the registration form now?",
  PRINT_TO_PDF: "Print to PDF",
  PRIORITY: "Priority",
  PRNT_CLM: "Display Claim",
  PROCESS_DATE: "Process Date",
  PROCESSED: "Processed",
  PROCESSED_PART_REQUESTS: "Processed Part Requests",
  PROCESSING_STATUS: "Processing Status",
  PROCESSING_STATUS_DESCRIPTION: "Processing Status Description",
  PRODUCT_DETAILS: "Product Details",
  PRODUCT_HIERARCHY: "Product Hierarchy",
  PRODUCT_INFORMATION: "Product Information",
  PRODUCT_REGISTERED: "Product Registered",
  PRODUCT_REGISTRATION: "Product Registration",
  PRODUCT_REGISTRATION_PENDED: "Product Registration is Pended",
  PRODUCT_TRACKING: "Product Tracking",
  PRODUCTS: "Products",
  PRODUCTS_BY_CUSTOMER: "Products by Customer",
  PRODUCTS_BY_CUSTOMER_PARTIAL_DATA_WARNING: "Historical PINs might be missing from search results due to a temporary system connectivity issue",
  PRODUCTS_WITH_COUNT: "Products ({count})",
  PROGRAM: "Program",
  PROGRAM_DESCRIPTION: "Program Description",
  PROGRAM_IS_REQUIRED: "Program is required.",
  PROGRAM_NAME: "Program Name",
  PROGRAM_NUMBER: "Program Number",
  PRT: "PRT",
  PRTS: "PRTs",
  PURCHASE_INFO: "Purchase Information",
  PURCHASE_ORDER: "Purchase Order",
  PURCHASE_ORDER_IS_REQUIRED: "Purchase Order is required",
  PURCHASER_TYPE: "Purchaser Type",
  PURCHASER_TYPE_REQUIRED: "Purchaser Type Required",
  PUSH_XML: "Resend XML",
  QTY: "Qty",
  QUALIFY_FOR_EMISSIONS: "Qualify for Emissions",
  QUANTITY: "Quantity",
  QUANTITY_1: "Quantity 1",
  QUANTITY_2: "Quantity 2",
  QUANTITY_3: "Quantity 3",
  QUANTITY_4: "Quantity 4",
  QUANTITY_5: "Quantity 5",
  QUANTITY_6: "Quantity 6",
  QUANTITY_7: "Quantity 7",
  QUANTITY_8: "Quantity 8",
  QUANTITY_9: "Quantity 9",
  QUANTITY_10: "Quantity 10",
  QUERY_MUST_CONTAIN_3_CHARACTERS: "Query must contain at least 3 characters",
  QUEST_DESC: "Questionable Description",
  QUESTIONABLE_PART: "Questionable Part",
  QUEUED: "Queued",
  REASON_FOR_CHANGE: "Reason for Change",
  REASON_FOR_DEBIT: "Reason for Debit",
  REASON_FOR_MISSING_PLATE: "Reason for Missing Plate",
  REASON_FOR_MISSING_PLATE_REQUIRED: "Reason for Missing Plate Required",
  REASON_FOR_OVERRIDE: "Reason for Override",
  REASON_FOR_REFUSAL: "Reason for Refusal",
  REASON_FOR_RETURN: "Reason for Return",
  REASON_FOR_RETURN_IS_REQUIRED: "Reason for Return is required",
  REASON_FOR_TRANSFER: "Reason for Transfer",
  REASON_FOR_TRANSFER_MUST_CONTAIN_ALPHANUMERIC_CHARACTERS: "Reason for Transfer must contain alphanumeric characters",
  RECIPIENT_DEALER_OR_TCSM: "Recipient(Dealer or TCSM)",
  RECIPIENT_MAILING: "Mailing Recipient",
  RECONCILE: "Reconcile",
  RECONCILE_CLAIM: "Reconcile Claim",
  RECONCILED: "Reconciled",
  RECORD_AUDIT: "Record Audit",
  RECORD_AUDIT_FOR: "Record Audit For {dealer}",
  RECORDS_FOUND: "{countToDisplay} {count, plural, one {record} other {records}} found",
  RECOVERABLE_TAXES: "Recoverable Taxes",
  RECOVERED: "Recovered",
  RECOVERED_WITH_MISSED_ADDITIVES: "Recovered With Missed Additives",
  RECOVERED_WITHOUT_ADDITIVES: "Recovered Without Additives",
  RECOVERY: "Recovery",
  RED_MUST_BE_LESS_THAN_YELLOW: "Red Indicator Value Must Be Less Than Yellow Indicator Value",
  REFERENCE_1: "Reference 1",
  REFERENCE_2: "Reference 2",
  REFERENCE_INFORMATION: "Reference Information",
  REFERENCE_NUMBER1: "Reference Number 1",
  REFERENCE_NUMBER2: "Reference Number 2",
  REGION: "Region",
  REGISTER: "Register",
  REGISTER_A_PRODUCT_BY_PIN: "Register a product by PIN",
  REGISTER_A_PRODUCT_TO_ADD: "Register Product to add to the Warranty System",
  REGISTER_ANOTHER_PRODUCT: "Register Another Product",
  REGISTER_PRODUCT: "Register Product",
  REGISTER_PRODUCT_AND_REGISTER_ANOTHER: "Register Product and Register Another",
  REGISTERED: "Registered",
  REGISTRATION: "Registration",
  REGISTRATION_DATE: "Registration Date",
  REGISTRATION_DATES: "Registration Dates",
  REGISTRATION_FORM: "Registration Form",
  REGISTRATION_HISTORY: "Registration History",
  REGISTRATION_NOT_ALLOWED: "Registration not allowed for this product",
  REGISTRATION_REVIEW: "Registration Review",
  REGISTRATION_REVIEW_TAB: "Registration Review ({count})",
  REGISTRATION_STATUS: "Registration Status",
  REGISTRATION_STATUS_CANNOT_BE_NEW: "Registration Status cannot be New",
  REGISTRATION_STATUS_REQUIRED: "Registration Status required",
  REGISTRATION_SUCCESS: "Registration Successful",
  REGISTRATION_TYPE: "Registration Type",
  REGISTRATION_TYPE_CANNOT_BE_NEW: "Registration Type cannot be New",
  REGISTRATION_TYPE_REQUIRED: "Registration Type required",
  REGISTRATION_UPDATED_SUCCESSFULLY: "Registration Updated successfully",
  REGISTRATIONS_REVIEW: "Registrations Review",
  REIMBURSED: "Reimbursed",
  REIMBURSED_AMOUNT: "Reimbursed Amount",
  REIMBURSED_PERCENTAGE: "Reimbursed Percentage",
  REIMBURSED_PERCENTAGE_INDICATOR: "Reimbursed Percentage Indicator",
  REIMBURSEMENT_DETAILS: "Reimbursement Details",
  REIMBURSEMENT_PERCENTAGE: "Reimbursement Percentage",
  REIMBURSEMENT_SUMMARY: "Reimbursement Summary",
  REJECT: "Reject",
  REJECT_LABOR_RATE: "Reject Labor Rate",
  REJECT_SPECIAL_ALLOWANCE_CLAIM: "Reject Special Allowance Claim",
  REJECTED: "Rejected",
  REJECTED_APPEAL: "Rejected Appeal",
  RELATIONSHIP: "Relationship",
  RELATIONSHIP_IS_REQUIRED: "Relationship is required",
  REMOVE_FILTER: "Remove Filter",
  REMOVE_FROM_AUDIT: "Remove from Audit",
  REMOVE_LAYOUT: "Remove Layout",
  RENTAL_PINS: "Rental PINs",
  REPAIR_DATE: "Repair Date",
  REPAIR_DATE_CANNOT_BE_BEFORE_FAILURE_DATE: "Repair date cannot be before failure date",
  REPAIR_NUMBER: "Repair Number",
  REPAIR_NUMBER_IS_REQUIRED: "Repair Number is required",
  REPAIR_REPLACE_INDICATOR: "Repair/Replace Indicator",
  REPAIRED: "Repaired",
  REPAIRED_DATE: "Repaired Date",
  REPAIRED_DATE_CANNOT_BE_BEFORE_FAILED_DATE: "Repaired date cannot be before failed date",
  REPAIRED_DATE_IS_REQUIRED: "Repaired Date is required",
  REPORT_DATE: "Report Date",
  REPORT_NUMBER: "Report Number",
  REPORTS: "Reports",
  REQ_ADDL: "Adjust Credit",
  REQUEST_DATE: "Request Date",
  REQUEST_DETAILS: "Request Details",
  REQUEST_DUPLICATE_PIN_PLATE: "Request Duplicate PIN Plate",
  REQUEST_FORM: "Request Form",
  REQUEST_PIP_CODE: "Request PIP Code",
  REQUEST_STATUS: "Request Status",
  REQUEST_SUBMITTED: "Request Submitted",
  REQUEST_TYPE: "Request Type",
  REQUEST_UPDATED_SUCCESSFULLY: "Request Updated Successfully",
  REQUEST_WARRANTY_CLAIM_DEBIT: "Request Warranty Claim Debit",
  REQUESTED: "Requested",
  REQUESTED_BY: "Requested By",
  REQUESTED_DATE: "Requested date",
  REQUESTED_DATES: "Requested Dates",
  REQUESTED_DIAGNOSTIC_AMOUNT: "Requested Diagnostic Amount",
  REQUESTED_DIAGNOSTIC_HOURS: "Requested Diagnostic Hours",
  REQUESTED_LABOR_AMOUNT: "Requested Labor Amount",
  REQUESTED_LABOR_HOURS: "Requested Labor Hours",
  REQUESTED_OTHER_CREDITS: "Requested Other Credits",
  REQUESTED_PARTS: "Requested Parts",
  REQUESTED_REPAIR_AMOUNT: "Requested Repair Amount",
  REQUESTED_REPAIR_HOURS: "Requested Repair Hours",
  REQUESTED_TRAVEL_TOTAL: "Requested Travel Total",
  REQUESTER_TCSM: "Requester(TCSM)",
  REQUESTER_TCSM_REQUIRED: "Requester(TCSM) Required",
  REQUIRED: "required",
  REQUIRED_CRITERIA: "Required Criteria",
  REQUIRED_ITEMS: "Required Items",
  RESEND_XML: "Resend XML",
  RESET: "Reset",
  RESPONDENT_INFORMATION: "Respondent Information",
  RESPONSIBILITY_OF: "Responsibility of",
  RESPONSIBLE_ACCOUNT: "Responsible Account",
  RESPONSIBLE_ACCOUNT_IS_REQUIRED: "Responsible account is required",
  RESPONSIBLE_DEALER: "Responsible Dealer",
  RET: "Return",
  RETAIL_INSTALL: "Retail/Install",
  RETAIL_INSTALL_DATE: "Retail/Install Date",
  RETAIL_INSTALL_IS_REQUIRED: "Retail/Install is required",
  RETAILER_NAME: "Retailer Name",
  RETAILER_NAME_IS_REQUIRED: "Retailer Name is required",
  RETRY: "Retry",
  RETURN: "Return",
  RETURN_LABOR_RATE: "Return Labor Rate",
  RETURN_REQUEST: "Return Request",
  RETURN_SPECIAL_ALLOWANCE_CLAIM: "Return Special Allowance Claim",
  RETURN_STATUS: "Return Status",
  RETURNED: "Returned",
  RETURNED_DATE_CANNOT_BE_BEFORE_DELIVERED_DATE: "Returned date cannot be before delivered date",
  RETURNED_DATE_IS_REQUIRED: "Returned date is required",
  REVIEW_DEALER_RECOMMENDATIONS: "Are you sure you want to mark the pin for Review ?",
  REVISE: "Revise",
  REVISED: "Revised",
  ROLLING_12_CREDIT_AMOUNT: "Rolling 12 Credit Amount",
  ROLLING_12_MONTHS: "Rolling 12 months",
  RUN_REPORT: "Run Report",
  RUSSIAN: "Russian",
  SAP_DOWN_WARNING: "Warranty System functionality is impaired. We are working to correct this as quickly as possible. Refresh the browser to check system availability.",
  SAVE: "Save",
  SAVE_AS_DRAFT: "Save as Draft",
  SAVE_AS_NEW_LAYOUT: "Save as New Layout",
  SAVE_AUDIT: "Save Audit",
  SAVE_CHANGES: "Save Changes",
  SAVE_TO_VALIDATE: "Save to Validate",
  SAVE_VALD: "Save and Validate",
  SAVE_VALIDATE: "Save and Validate",
  SEARCH: "Search",
  SEARCH_BOX_PLACEHOLDER: "Enter PIN, Serial #, Claim #, DTAC Case, or Customer Name",
  SEARCH_BY_CLAIM_TYPE: "Enter full claim type",
  SEARCH_BY_CLAIM_TYPE_VALIDATION_FAIL: "Claim search must be by full claim type, from 4 to 9 characters",
  SEARCH_BY_FAILURE_PART_NUMBER: "Enter full failure part number",
  SEARCH_BY_FAILURE_PART_NUMBER_VALIDATION_FAIL: "Claim search must be by full failure part number, at least 4 characters",
  SEARCH_BY_WORK_ORDER: "Enter Work Order, minimum 2 characters",
  SEARCH_BY_WORK_ORDER_VALIDATION_FAIL: "Work Order search must be at least 2 characters",
  SEARCH_PRODUCT_BY_CLAIM_PLACEHOLDER: "Enter full Claim number",
  SEARCH_PRODUCT_BY_CLAIM_VALIDATION_FAIL: "Claim search must be by full claim number, from 4 to 9 characters",
  SEARCH_PRODUCT_BY_COMPONENT_PLACEHOLDER: "Enter full Component serial number",
  SEARCH_PRODUCT_BY_COMPONENT_VALIDATION_FAIL: "Component search must be by full serial number, at least 1 character",
  SEARCH_PRODUCT_BY_FULL_PIN_PLACEHOLDER: "Enter PIN",
  SEARCH_PRODUCT_BY_MODEL_PLACEHOLDER: "Enter full Model number",
  SEARCH_PRODUCT_BY_MODEL_VALIDATION_FAIL: "Model search must be full model number, from 3 to 12 characters",
  SEARCH_PRODUCT_BY_PIN_PLACEHOLDER: "Enter PIN, minimum 6 characters",
  SEARCH_PRODUCT_BY_PIN_VALIDATION_FAIL: "PIN search must be from 6 to 17 characters",
  SEARCH_PRODUCT_BY_PIP_PLACEHOLDER: "Enter PIP Number, minimum 4 characters",
  SEARCH_PRODUCT_BY_PIP_VALIDATION_FAIL: "PIP search must be from 4 to 12 characters",
  SEARCH_RESULTS_TAB: "Search Results ({count})",
  SECOND_SHIP_TO_LOCATION: "Second Ship To Location",
  SELECT: "Select",
  SELECT_A_RANGE: "Select a range",
  SELECT_ALL: "Select All",
  SELECT_AUTO_SUBMIT: "Select Auto Submit",
  SELECT_BRANCH: "Select Branch",
  SELECT_CLAIM_TYPE: "Select Claim Type",
  SELECT_CLAIMS: "Select Claims",
  SELECT_CLAIMS_WITHIN_DATE_RANGE: "Select Claims Within Date Range",
  SELECT_COLUMNS: "Select Columns",
  SELECT_COUNTRY: "Select Country",
  SELECT_CSV_SEPARATOR: "Select CSV Separator",
  SELECT_DATE_FORMAT: "Select Date Format",
  SELECT_DEALERS_AND_STATUS: "Select Dealers and Status",
  SELECT_DECIMAL_FORMAT: "Select Decimal Format",
  SELECT_DISPLAY_FORMAT: "Select Display Format",
  SELECT_FACTORY: "Select Factory",
  SELECT_LANGUAGE: "Select Language",
  SELECT_LAYOUT: "Select Layout",
  SELECT_NEW_CLAIMS: "Select New Claims",
  SELECT_PIP_CODE: "Select PIP Code",
  SELECT_PLAN_NAMES: "Select Plan Names",
  SELECT_SERVICE_INTERVAL_TYPES: "Select Service Interval Types",
  SELECT_SORT_BY: "Select Sort By",
  SELECT_SORT_DIRECTION: "Select Sort Direction",
  SELECT_STATE: "Select State",
  SELECT_STATUS: "Select Status",
  SELECT_TERRITORY: "Select Territory",
  SELECT_THEME: "Select Theme",
  SELECT_TIME_ZONE: "Select Time Zone",
  SELECT_VALUES_TO_APPROVE: "Select Values to Approve",
  SELECTED_COLUMNS: "Selected Columns",
  SELECTED_FOR_AUDIT: "Selected for Audit",
  SELECTED_FOR_AUDIT_VSR: "See DTAC Solution 221475 for the required audit documentation and attachments needed for this claim",
  SELECTING_MULTIPLE_ACCOUNTS_AND_WARRANTY_TYPES_IMPACTS_PERFORMANCE: "Selecting multiple Accounts & Warranty Types impacts performance",
  SEND: "Send",
  SERIAL_NUMBER: "Serial Number",
  SERIAL_NUMBER_INVOICE_NUMBER: "Serial Number / Invoice Number",
  SERVER_TOOK_TOO_LONG_TO_REPLY: "Server took too long to reply and the request has been cancelled. Please try a more specific request or try again later.",
  SERVICE_DATE_IS_REQUIRED: "Service Date is Required",
  SERVICE_INTERVAL: "Service Interval",
  SERVICE_INTERVAL_BEGIN_DATE: "Service Interval Begin Date",
  SERVICE_INTERVAL_END_DATE: "Service Interval End Date",
  SERVICE_INTERVAL_IS_REQUIRED: "Service Interval is Required",
  SERVICE_INTERVAL_NUMBER: "Service Interval Number",
  SERVICE_INTERVAL_STATUS: "Service Interval Status",
  SERVICE_INTERVAL_TYPE: "Service Interval Type",
  SERVICE_INTERVAL_TYPES: "Service Interval Types",
  SERVICE_PART: "Service Part",
  SERVICE_UNAVAILABLE: "Service Unavailable",
  SERVICED: "Serviced",
  SERVICED_DATE_IS_REQUIRED: "Serviced Date is Required",
  SERVICED_IS_REQUIRED: "Serviced is required.",
  SET_AS_DEFAULT: "Set as Default",
  SETTINGS: "My Settings",
  SETTLED: "Settled",
  SETTLEMENT_NO_REGISTRATION: "Settlement, No Registration",
  SETUP: "Setup",
  SETUP_DATE_IS_REQUIRED: "Setup Date is required",
  SETUP_IS_REQUIRED: "Setup is required",
  SGST_UTGST: "SGST/UTGST",
  SHIP_TO: "Ship To",
  SHIPPED: "Shipped",
  SHIPPING_INFORMATION_SPECIAL_INSTRUCTIONS: "Shipping Information/Special Instructions",
  SHIPPING_INSTRUCTIONS: "Shipping Instructions",
  SHORT_TEXT: "Short Text",
  SHORT_TEXT_IS_REQUIRED: "Short Text is Required",
  SHOW_ALL: "Show All ({count})",
  SHOW_EXCLUDED: "Show Excluded",
  SHOW_MORE: "Show More",
  SHOW_MORE_GROUPS: "Show {countToDisplay} more {count, plural, one {group} other {groups}}",
  SHOW_RED_IF_LESS_THAN: "Show Red if Less Than",
  SHOW_REIMBURSED_AMOUNT: "Show Reimbursed Amount",
  SHOW_REIMBURSED_PERCENTAGE: "Show Reimbursed Percentage",
  SHOW_YELLOW_IF_LESS_THAN: "Show Yellow if Less Than",
  SIGN_IN_REQUIRED: "Sign In Required",
  SIGN_OUT: "Sign Out",
  SKIP_AUDIT: "Skip Audit",
  SKIP_AUDIT_SUCCESS: "Audit has been skipped and due date is now in the future.",
  SOME_PARTS_RETURNED: "Some Parts Returned",
  SORT_BY: "Sort By",
  SPANISH: "Spanish",
  SPECIAL_ALLOWANCE: "Special Allowance",
  SPECIAL_ALLOWANCE_CALCULATION: "Special Allowance Calculation",
  SPECIAL_ALLOWANCE_CLAIM: "Special Allowance Claim",
  SPECIAL_ALLOWANCE_CLAIM_STATUS: "Special Allowance Claim Status",
  SPECIAL_ALLOWANCE_CLAIM_STATUS_TABM: "Special Allowance Claim Status",
  SPECIAL_ALLOWANCE_CLAIM_STATUS_UPDATED: "Special Allowance Claim Status Updated",
  SPECIAL_ALLOWANCE_CLAIM_WITH_ID: "Special Allowance Claim - {claimNumber}",
  SPECIAL_ALLOWANCE_CLAIMS_WITH_COUNT: "Special Allowance Claims ({count})",
  SPECIAL_ALLOWANCE_CONTRIBUTIONS: "Special Allowance Contributions",
  SPECIAL_ALLOWANCE_DESCRIPTION: "Special Allowance Description",
  SPECIAL_ALLOWANCE_TYPE: "Special Allowance Type",
  SPECIAL_ALLOWANCE_TYPE_IS_REQUIRED: "Special Allowance Type is Required",
  SPECIAL_INSTRUCTIONS: "Special Instructions",
  SPG: "SPG",
  SPGS: "SPGs",
  STANDARD_VIEW: "Standard View",
  START_AMOUNT_OF_USE: "Start Amount of Use",
  STARTS: "Starts",
  STARTS_WITH: "Starts with",
  STATE: "State",
  STATE_PROVINCE: "State/Province",
  STATE_PROVINCE_REQUIRED: "State/Province Required",
  STATUS: "Status",
  STATUS_CHANGE_REQUEST: "Status Change Request",
  STATUS_CHANGE_REQUEST_CREATED_SUCCESSFULLY: "Status change request created successfully",
  STATUS_FOR: "Status for {pin}",
  STATUS_INDICATOR: "Status Indicator",
  STATUS_REASON: "Status Reason",
  STOLEN_DATE: "Stolen Date",
  STORE: "Store",
  STORE_IS_REQUIRED: "Store is required",
  STORE_NUMBER_IS_REQUIRED: "Store Number is required",
  STREET_1: "Street 1",
  STREET_2: "Street 2",
  SUB: "Submit",
  SUB_CLAIM_TYPE: "Sub Claim Type",
  SUB_TYPE: "Subtype",
  SUBMISSION_DATE: "Submission Date",
  SUBMIT: "Submit",
  SUBMIT_AUDIT: "Submit Audit",
  SUBMIT_AUDIT_FOR: "Submit Audit For {dealer}",
  SUBMIT_FULL_DEBIT_CLAIM_FOR_WITH_CLAIM_NUMBER: "Submit Full Debit Claim for {claimNumber}",
  SUBMIT_PARTIAL_DEBIT_CLAIM_FOR_WITH_CLAIM_NUMBER: "Submit Partial Debit Claim for {claimNumber}",
  SUBMIT_PERCENTAGE_DEBIT_CLAIM_FOR_WITH_CLAIM_NUMBER: "Submit Percentage Debit Claim for {claimNumber}",
  SUBMIT_REQUEST: "Submit Request",
  SUBMITTED: "Submitted",
  SUBMITTED_AVAILABLE_TO_EDIT: "Submitted (Editable)",
  SUCCESS: "Success",
  SUCCESS_MESSAGE_TITLE: "An operation was successful:",
  SUCCESS_MESSAGES_TITLE: "Multiple operations were successful:",
  SUPPLIER_WARRANTY: "Supplier Warranty",
  SURVEY_QUESTIONS: "Survey Questions",
  SUSPENDED: "Suspended",
  SWEDISH: "Swedish",
  SYSTEM_SELECTED_CLAIMS: "System Selected Claims",
  SYSTEM_SELECTED_CLAIMS_WITH_COUNT: "System Selected Claims ({count})",
  TABM: "TABM",
  TAX: "Tax",
  TCSM: "TCSM",
  TECH_ID: "Tech ID",
  TERMINATED: "Terminated",
  TERMINATES: "Terminates",
  TERRITORY: "Territory",
  TEST: "Test",
  TEST_RESULTS_CODE: "Test Results Code",
  THEME: "Theme",
  TIME_LIMIT: "Time Limit",
  TIME_ZONE: "Time Zone",
  TITLE: "Title",
  TITLE_IS_REQUIRED: "Title is Required",
  TO: "To",
  TODAY: "Today",
  TOO_MANY_RESULTS: "Your request returned too many results. Please narrow your search terms and try again.",
  TOTAL: "Total",
  TOTAL_AMOUNT: "Total Amount",
  TOTAL_APPROVED: "Total Approved",
  TOTAL_APPROVED_CLAIM_VALUE: "Total Approved Claim Value",
  TOTAL_APPROVED_INCLUDING_TAXES: "Total Approved Including Taxes",
  TOTAL_APPROVED_WITHOUT_ADDITIVES: "Total Approved Without Additives",
  TOTAL_CONTRIBUTION: "Total Contribution",
  TOTAL_REIMBURSED: "Total Reimbursed",
  TOTAL_REIMBURSED_WITH_CURRENCY: "Total Reimbursed ({currency})",
  TOTAL_REQUESTED: "Total Requested",
  TOTAL_REQUESTED_CLAIM_VALUE: "Total Requested Claim Value",
  TOTAL_UNPAID: "Total Unpaid",
  TRACKING_NUMBER: "Tracking Number",
  TRANSFER: "Transfer",
  TRANSFER_APPROVALS: "Transfer Approvals",
  TRANSFER_APPROVALS_TAB: "Transfer Approvals ({count})",
  TRANSFER_CREATED: "Transfer Created",
  TRANSFER_DEALER_RECOMMENDATIONS: "Are you sure you want to transfer the pin to other dealer ?",
  TRANSFER_UPDATED_SUCCESSFULLY: "Transfer updated successfully",
  TRANSFERS: "Transfers",
  TRAVEL: "Travel",
  TURKISH: "Turkish",
  TWO_PERCENT_WITHHOLD_VALUE: "2% Withhold Value",
  TYPE: "Type",
  TYPES: "Types",
  UNABLE_TO_CONTACT_THE_SERVER: "Unable to contact the server",
  UNABLE_TO_LOAD_CUSTOMER_DETAILS: "Unable to load customer details",
  UNDO: "Undo",
  UNDO_REGISTRATION: "Undo Registration",
  UNDO_REGISTRATION_SUCCESSFULL: "Undo Registration is Successfull",
  UNIT: "Unit",
  UNIT_1: "Unit 1",
  UNIT_2: "Unit 2",
  UNIT_3: "Unit 3",
  UNIT_OF_MEASURE: "Unit of Measure",
  UNPAID_LABOR: "Unpaid Labor",
  UNPAID_LABOR_ADDITIVES_EXCLUDING_PIPS: "Unpaid Labor Additives - Excluding PIPs",
  UNPAID_LABOR_ADDITIVES_PIPS: "Unpaid Labor Additives - PIPs",
  UNPAID_OTHER_CREDITS: "Unpaid Other Credits",
  UNPAID_PARTS: "Unpaid Parts",
  UNPAID_PARTS_ADDITIVE: "Unpaid Parts Additive",
  UNPAID_TRAVEL: "Unpaid Travel",
  UNSUB: "Unsubmit",
  UNSUBMIT_CLAIM: "Unsubmit Claim",
  UPDATE_CUSTOMER_INFORMATION: "Update Customer Information",
  UPDATE_LABOR_RATES: "Update Labor Rates",
  UPDATE_LAYOUT: "Update Layout",
  UPDATE_MACHINE_STATUS: "Update Machine Status",
  UPDATE_MACHINE_STATUS_HISTORY: "Update Machine Status History",
  UPDATE_REGISTRATION: "Update Registration",
  UPDATE_SELECTED: "Update Selected",
  UPDATED: "Updated",
  UPDATED_BY: "Updated By",
  UPLOAD_DOCUMENT: "Upload Document",
  UPTIME_ASSURANCE: "Uptime Assurance",
  USEFUL_LINKS: "Useful Links",
  USER: "User",
  USER_PREFERENCES_UPDATED: "User preferences updated",
  USER_SELECTED: "User Selected",
  USER_SELECTED_CLAIMS_WITH_COUNT: "User Selected Claims ({count})",
  USERS_INFORMATION: "Users Information",
  VALIDATE: "Validate",
  VALIDATE_CLAIM: "Validate Claim",
  VALUE: "Value",
  VALUE_OF_REPAIR: "Value of Repair",
  VIEW_CLAIM: "View Claim",
  VIEW_DETAILS: "View Details",
  VIEW_OPEN_PIPS: "View Open PIPs",
  VIEW_PIP: "View PIP",
  VIEW_PRODUCTS: "View Products",
  VIEW_PRODUCTS_AND_UPDATE_INFO: "View Products & Update Info",
  VIEW_UPDATE: "View/Update",
  VSR_MESSAGES: "VSR Messages",
  WAITING_FOR_DLR_INV: "Waiting For Dealer Invoice",
  WAITING_FOR_INVOICE: "Waiting For Invoice ({count})",
  WAITING_SINCE: "Waiting Since",
  WARNING_MESSAGE_TITLE: "A warning was sent:",
  WARNING_MESSAGES: "Warning Messages",
  WARNING_MESSAGES_TITLE: "Multiple warnings were sent:",
  WARRANTY: "Warranty",
  WARRANTY_ADMIN: "Warranty Admin",
  WARRANTY_CLAIM_TYPE: "Warranty Claim Type",
  WARRANTY_COVERAGE: "Warranty Coverage",
  WARRANTY_EXPIRATION: "Warranty Expiration",
  WARRANTY_TYPE: "Warranty Type",
  WARRANTY_TYPES: "Warranty Types",
  WEAR_PARTS: "Wear Parts",
  WEAR_PARTS_COVERAGE: "Wear Parts Coverage",
  WELCOME: "Welcome",
  WIP: "Work in Progress",
  WITH_ADDITIVES: "With Additives",
  WITNESS_FIRST_NAME: "Witness First Name",
  WITNESS_LAST_NAME: "Witness Last Name",
  WORK_ORDER: "Work Order",
  WORK_ORDER_NUMBER: "Work Order Number",
  WORK_ORDER_ONE: "Work Order 1",
  WORK_ORDER_ONE_IS_REQUIRED: "Work Order 1 is required",
  WORK_ORDER_THREE: "Work Order 3",
  WORK_ORDER_THREE_IS_REQUIRED: "Work Order 3 is required",
  WORK_ORDER_TWO: "Work Order 2",
  WORK_REPAIR_ORDER: "Work Repair Order",
  YES: "YES",
  YES_LOWERCASE: "Yes"
});